<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch1">
<div class="chapterHead"><p class="centerImage0"><img alt="image" src="images/ch1.jpg" width="4%"/></p>
</div>
<p class="para" style="text-indent: 5%;">“Cool!” you exclaim to your best friends, Liz and Jake. “The field trip to the Wicked Wax Museum is today. I can’t believe our class gets to see it the day <em class="italic">before</em> the grand opening.”</p>
<p class="para" style="text-indent: 5%;">“Finally, Mr. Dunning’s History class won’t be such a bore,” Jake adds, flipping his black baseball cap around backward. “Mr. Dunning. More like Mr. Dull!”</p>
<p class="para" style="text-indent: 5%;">“You said it,” Liz giggles. Her red curls bounce when she laughs. “Hey, why is it called the Wicked Wax Museum, anyway?”</p>
<p class="para" style="text-indent: 5%;">“That’s the name of the guy who owns it,” Jake explains. “Dr. Izzy Wicked. He made all the wax figures.”</p>
<p class="para" style="text-indent: 5%;">“Well, according to Mr. Dull,” Liz adds, “the museum is supposed to bring history to life for us, or something like that.”</p>
<p class="para" style="text-indent: 5%;">“Yeah, right.” Jake smirks. “And maybe the wax figures will come to life, too.”</p>
<p class="para" style="text-indent: 5%;">“Oh, gross!” Liz cries. “You’re giving me the creeps, Jake.”</p>
<p class="para" style="text-indent: 5%;">“Come on, you two,” you say. “The bus is here. Let’s be first in line so we can grab the backseats.”</p>
<p class="extractLetterText" style="text-indent: 5%;"><em class="italic">Go to <a href="#/e9780545841733_ch002">PAGE 2</a>.</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9780545841733_ch001.vue?caa2e63e